module.exports = __webpack_public_path__ + "img/logo_evidence.6123b6bf.png";